function toggleVideo(video, button) {
    button.classList.toggle('video__play--paused');
    button.setAttribute('title', button.getAttribute('title') === 'play' ? 'pause' : 'play');

    if (video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2) {
        video.pause();
    } else {
        video.play();
    }
}
export default function videoTogglers() {
    let videoTags = document.querySelectorAll('video');
    if (!videoTags) { return false; }
    Array.from(videoTags).forEach((video) => {
        const anchor = document.createElement('a');
        const mute = document.createElement('a');
        anchor.classList.add('video__play');
        mute.classList.add('video__mute');
        anchor.setAttribute('title', 'play');
        mute.setAttribute('title', 'unmute');
        if (!video.autoplay) {
            anchor.classList.add('video__play--paused');
        }

        if (!video.muted) {
            muted.classList.add('video__muted--unmute');
        }

        anchor.innerText = 'Play';
        mute.innerText = 'Unmute';

        anchor.addEventListener('click', event => {
            event.preventDefault();
            toggleVideo(event.currentTarget.parentElement.querySelector('video'), event.currentTarget);
        });

        mute.addEventListener('click', function(event) {
            event.preventDefault();

            this.classList.toggle('video__mute--unmuted');
            this.setAttribute('title', this.getAttribute('title') === 'mute' ? 'unmute' : 'mute');

            if (!video.muted) {
                video.muted = true
            } else {
                video.muted = false;
            }

        });

        video.addEventListener('click', () => {
            event.preventDefault();
            toggleVideo(event.currentTarget, event.currentTarget.parentElement.querySelector('.video__play'));
        });
        video.parentElement.appendChild(anchor);
        if(!video.hasAttribute('data-mute')) {
            video.parentElement.appendChild(mute);
        }
    });
}
